// GLOBALS
// Initial State
let initialState = {
  commissions: [],
  commissionsReports: [],
  charge: {},
  fetching: false,
  error: null
}

// Pagination
const RESET_ERROR = 'RESET_ERROR'

// Get Commissions
const GET_COMMISSIONS = 'GET_COMMISSIONS'
const GET_COMMISSIONS_SUCCESS = 'GET_COMMISSIONS_SUCCESS'
const GET_COMMISSIONS_FAILURE = 'GET_COMMISSIONS_FAILURE'
// POST Commission Charge
const POST_COMMISSION_CHARGE = 'GET_COMMISSIONS'
const POST_COMMISSION_CHARGE_SUCCESS = 'PUT_COMMISSIONS_SUCCESS'
const POST_COMMISSION_CHARGE_FAILURE = 'PUT_COMMISSIONS_FAILURE'
//PUT Commission Charge
const PUT_COMMISSIONS = 'PUT_COMMISSIONS'
const PUT_COMMISSIONS_SUCCESS = 'PUT_COMMISSIONS_SUCCESS'
const PUT_COMMISSIONS_FAILURE = 'PUT_COMMISSIONS_FAILURE'
// GET Commissions Reports
const GET_COMMISSIONS_REPORTS = 'GET_COMMISSIONS_REPORTS'
const GET_COMMISSIONS_REPORTS_SUCCESS = 'GET_COMMISSIONS_REPORTS_SUCCESS'
const GET_COMMISSIONS_REPORTS_FAILURE = 'GET_COMMISSIONS_REPORTS_FAILURE'
// GET Commission Report PDF link
const GET_COMMISSIONS_PDF_DOWNLOAD_LINK = 'GET_COMMISSIONS_PDF_DOWNLOAD_LINK'
const GET_COMMISSIONS_PDF_DOWNLOAD_LINK_SUCCESS = 'GET_COMMISSIONS_PDF_DOWNLOAD_LINK_SUCCESS'
const GET_COMMISSIONS_PDF_DOWNLOAD_LINK_FAILURE = 'GET_COMMISSIONS_PDF_DOWNLOAD_LINK_FAILURE'

export const resetError = () => {
  return {
    type: RESET_ERROR
  }
}

export const getCommissions = (orgID, date) => {
  return ({
    types: [GET_COMMISSIONS, GET_COMMISSIONS_SUCCESS, GET_COMMISSIONS_FAILURE],
    payload: {
      request: {
        url: date ? `/commissions/${orgID}?date=${date}` : `/commissions/${orgID}`,
        method: 'GET',
      }
    }
  })
}

export const putCommissions = (orgID, data) => {
  return ({
    types: [PUT_COMMISSIONS, PUT_COMMISSIONS_SUCCESS, PUT_COMMISSIONS_FAILURE],
    payload: {
      request: {
        url: `/commissions/${orgID}`,
        method: 'PUT',
        data
      }
    }
  })
}

export const chargeCommission = (orgID, data) => {
  return ({
    types: [POST_COMMISSION_CHARGE, POST_COMMISSION_CHARGE_SUCCESS, POST_COMMISSION_CHARGE_FAILURE],
    payload: {
      request: {
        url: `/commissions/charge/${orgID}`,
        method: 'POST',
        data
      }
    }
  })
}

export const getCommissionsReports = (orgID) => {
  return ({
    types: [GET_COMMISSIONS_REPORTS, GET_COMMISSIONS_REPORTS_SUCCESS, GET_COMMISSIONS_REPORTS_FAILURE],
    payload: {
      request: {
        url: `/commissions/organisation/${orgID}`,
        method: 'GET',
      }
    }
  })
}

export const getCommissionReportDownloadLink = (report, callback) => {
  const { organisation_id: orgID, year, month } = report
  return ({
    types: [GET_COMMISSIONS_PDF_DOWNLOAD_LINK, GET_COMMISSIONS_PDF_DOWNLOAD_LINK_SUCCESS, GET_COMMISSIONS_PDF_DOWNLOAD_LINK_FAILURE],
    payload: {
      request: {
        url: `/commissions/organisation/${orgID}/year/${year}/month/${month}`,
        method: 'GET',
      }
    },
    callback
  })
}

const commissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ERROR:
      return {
        ...state, error: null
      }
      case GET_COMMISSIONS:
        return {
          ...state,
          fetching: true,
        }
      case GET_COMMISSIONS_SUCCESS:
        return {
          ...state,
          fetching: false,
          commissions: action.payload.data.commissions ? action.payload.data.commissions : action.payload.data,
        }
      case GET_COMMISSIONS_FAILURE:
        return {
          ...state,
          fetching: false
        }
      case POST_COMMISSION_CHARGE:
        return {
          ...state,
          fetching: true,
        }
      case POST_COMMISSION_CHARGE_SUCCESS:
          return {
            ...state,
            fetching: false,
            charge: action.payload.data.payments 
          }
      case POST_COMMISSION_CHARGE_FAILURE:
          return {
            ...state,
            fetching: false,
          }
      case GET_COMMISSIONS_REPORTS:
        return {
          ...state,
          fetching: true
        }
      case GET_COMMISSIONS_REPORTS_SUCCESS:
        return {
          ...state,
          fetching: false,
          error: action.payload.data.error ? action.payload.data.error.text : null,
          commissionsReports: action.payload.data.error ? [] : action.payload.data
        };
      case GET_COMMISSIONS_REPORTS_FAILURE:
        return {
          ...state,
          fetching: false,
          error: action.payload.data.error && action.payload.data.error.text
        }
      case GET_COMMISSIONS_PDF_DOWNLOAD_LINK:
        return {
          ...state,
          fetching: true
        }
      case GET_COMMISSIONS_PDF_DOWNLOAD_LINK_SUCCESS:
        if (!action.payload.data.error) {
          action.meta.previousAction.callback({ ...action.payload.data })
        }

        return {
          ...state,
          fetching: false,
          error: action.payload.data.error ? action.payload.data.error.text : null
        };
      case GET_COMMISSIONS_PDF_DOWNLOAD_LINK_FAILURE:
        return {
          ...state,
          fetching: false,
          error: action.payload.data.error && action.payload.data.error.text
        }
      default:
        return state
  }
}

export default commissionsReducer;
